function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.1204 9.05518C5.86709 8.72642 6.10144 8.25 6.51647 8.25H11.4583H16.4002C16.8152 8.25 17.0496 8.72642 16.7963 9.05518L16.4759 9.47099L11.818 14.2942C11.6214 14.4978 11.2952 14.4978 11.0987 14.2942L6.44079 9.47099L6.1204 9.05518Z",
  fill: "currentColor"
});
function SvgDropdownArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowDown);
export default __webpack_public_path__ + "static/media/DropdownArrowDown.be7a561ad3485a5dba30f62f42f7d3d0.svg";
export { ForwardRef as ReactComponent };